import { Avatar, Box, chakra } from "@chakra-ui/react";

export const StyledSidebarContainer = chakra(Box, {
  baseStyle: {
    width: "340px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    transition: "all",
    transitionDuration: "0.3s",
    transitionProperty: "all",

    bgColor: "theme.bg.box",
  },
});

export const StyledSidebarSubBox = chakra(Box, {
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flex: 1,
    overflowY: "scroll",
  },
});

export const StyledSidebarItem = chakra(Box, {
  baseStyle: {
    display: "flex",
    borderRadius: "8px",
    gap: "14px",
    padding: "16px",
    cursor: "pointer",
  },
});

export const StyledUserTag = chakra(Box, {
  baseStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    bg: "theme.alert.200",
    borderRadius: "4px",
    color: "theme.button.primary",
    fontSize: "10px",
    fontWeight: 500,
    paddingX: "5px",
    height: "18px",
    noOfLines: 1,
    maxW: "80px",
    textOverflow: "ellipsis",
    whiteSpace: "pre-wrap",
  },
});

export const StyledResLaguageContainer = chakra(Box, {
  baseStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    cursor: "pointer",
  },
});
export const LaguageTogglerContainer = chakra(Box, {
  baseStyle: {
    alignItems: "center",
    bg: "#F3F4F6",
    borderRadius: "10px",
    fontWeight: "500",
    fontSize: "14px",
    p: "4px",
    h: "38px",
    color: "#2F2F34",
    maxW: "200px",
    mb: "5",
    justifyContent: "center",
  },
});
export const StyledProfileAvatar = chakra(Avatar, {
  baseStyle: {
    width: "40px",
    height: "40px",
    fontSize: "13px",
    fontWeight: 500,
    bg: "purple.200",
    cursor: "pointer",
    color: "theme.button.primary",
  },
});
